import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { FormRVHook } from "./formRVHook";

export const ModalFormRV = ({
  dataState,
  close,
  open,
  id_product,
  idProspecto,
  investmentProfile,
  uuid,
}: any) => {
  function validateValues({ valuesPdf }: any) {
    if (valuesPdf.length === 0) {
      return true;
    }

    if (valuesPdf.length > 9) {
      return false;
    }

    return true;
  }
  const [openModalMessage, setOpenModalMessage] = useState(false);
  const handleClear = () => {
    setOpenModalMessage(true);
  };
  const [alertRV, setAlertRV] = useState<boolean>(false);

  const [isClear, setIsClear] = useState(false);

  const closeModal = () => {
    close(id_product);
  };

  useEffect(() => {
    if (open) {
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
    } else {
      document.getElementsByTagName("body")[0].style.overflow = "auto";
    }
  }, [open, isClear]);

  return (
    <div className={`modalFormRG  flex col ${open ? "is-open" : ""}`}>
      <FormRVHook
        dataState={dataState}
        submitValues={() => {}}
        onClick={() => {}}
        investmentProfile={investmentProfile}
        isError={alertRV}
        close={close}
      />
      <ToastContainer containerId={"RV"} />
    </div>
  );
};
